
/**
 *  { name: "XXX", value: XXX },
 */
export default [
  // 是否忽略关键目录设置 详见src/CommonDP/router/method/method.js下的beforeEachproject方法实现
  { name: "isIgnoreDirPlan", value: true },

  // 自定义接口地址替换
  { name: "url:/doc/list", value: "/lc/doc/list" },
  { name: "url:/drawing-annotation/list", value: "/lc/drawing-annotation/list" },
  { name: "url:/doc/download/${prjId}/${fileId}", value: "/lc/doc/download" },
  { name: "url:/comment/add", value: "/lc/comment/add" },
  { name: "url:/enterprise/personnel/update", value: "/lc/enterprise/personnel/update" },
  { name: "url:/integrationModel/addIntegrationModelLog", value: "/lc/integrationModel/addIntegrationModelLog" },
  { name: "url:/doc/permission/query", value: "/lc/doc/permission/query" },
  { name: "url:/drawing-annotation/updateModifier", value: "/lc/drawing-annotation/updateModifier" },
  { name: "url:/prj-plan-task/upAndDown", value: "/lc/prj-plan-task/upAndDown" },
  { name: "url:/log/system", value: "/lc/log/system" },
  { name: "url:/flow/specRole/queryTree", value: "/lc/flow/specRole/queryTree" },
  { name: "url:/prj-person-plan/queryUserTree", value: "/lc/flow/queryUserTree" },
  { name: "url:/flowNew/assigneeStrategy/list", value: "/dic/content/list?dicCode=AssigneeStrategy" },
];
